export default __webpack_public_path__ + "static/media/dp-dope.1f8e3263.png";